<!-- CN-8312: Kanban View - Compact card layout for V3 -->
<div *ngIf="isKanbanView && projectCarrierMapList?.length > 0" class="kanban-cards-container">
	<cdk-virtual-scroll-viewport
		itemSize="85"
		[minBufferPx]="20"
		[maxBufferPx]="40"
		style="flex: 1; overflow: auto"
	>
		<div
			*cdkVirtualFor="let projectCarrierMap of projectCarrierMapList; let cIndex = index; trackBy: trackByFn"
			class="kanban-card"
			tabindex="0"
			role="button"
			(click)="emitPanelClickedEvent(projectCarrierMap, $event, cIndex, false)"
			(keydown.enter)="emitPanelClickedEvent(projectCarrierMap, $event, cIndex, false)"
			[ngClass]="{
				'kanban-card-selected': selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id) > -1
			}"
			[attr.id]="'kanban-' + projectCarrierMap.id"
			draggable
			[dragData]="projectCarrierMap"
			dragImage="assets/icons/drag_indicator.svg"
			(dragend)="dragend()"
			(dragstart)="drag($event, projectCarrierMap)"
			dragTransitClass="no-border"
		>
			<!-- Row 1: Carrier Name/Icons, MC/DOT, Match Confidence -->
			<div class="kanban-row">
				<div class="kanban-cell carrier-name-cell">
					<span
						[class.font-weight-bold]="projectCarrierMap.carrier.customerCarrier"
						class="carrier-name ellipsis"
					>
						{{ GET_CARRIER_BUSINESS_NAME(projectCarrierMap.carrier.businessName, projectCarrierMap.carrier.doingBusinessAs) }}
					</span>
					<img
						*ngIf="
							SHOW_IN_NETWORK_LOGO(
								CARRIER_QUALITY_ENABLED,
								projectCarrierMap.carrier.dot,
								isCarrierVettingIntegrationEnabled,
								getVettingSource(projectCarrierMap.carrier.accountCarrierMaps),
								getVettingSourceId(projectCarrierMap.carrier.accountCarrierMaps),
								carrierVettingService,
								projectCarrierMap.carrier.id,
								projectCarrierMap.carrier.customerCarrier
							)
						"
						[src]="carrierVettingService.logo(getVettingSource(projectCarrierMap.carrier.accountCarrierMaps))"
						class="kanban-icon"
					/>
					<span
						*ngIf="showOnboardCarrier(projectCarrierMap.carrier)"
						class="link ml-6 font-size-12"
						role="button"
						tabindex="0"
						(click)="$event.stopPropagation(); onboardCarrier(projectCarrierMap.carrier)"
						(keydown.enter)="$event.stopPropagation(); onboardCarrier(projectCarrierMap.carrier)"
						(keydown.space)="$event.preventDefault(); $event.stopPropagation(); onboardCarrier(projectCarrierMap.carrier)"
					>
						Onboard Carrier
					</span>
				</div>
				<div class="kanban-cell ellipsis" (click)="$event.stopPropagation()">
					<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.mc)">MC: {{ projectCarrierMap.carrier.mc }}</span>
					<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.mc) && IS_NOT_EMPTY(projectCarrierMap.carrier.dot)"> / </span>
					<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.dot)">DOT: {{ projectCarrierMap.carrier.dot }}</span>
				</div>
				<div class="kanban-cell">
					<meter
						*ngIf="projectCarrierMap.matchScore != null"
						high="66"
						low="33"
						max="100"
						min="0"
						optimum="90"
						[value]="projectCarrierMap.matchScore"
						[matTooltip]="'Match: ' + projectCarrierMap.matchScore + '%'"
						class="kanban-meter"
					></meter>
					<span *ngIf="projectCarrierMap.matchScore == null" class="font-size-11">N/A</span>
				</div>
			</div>

			<!-- Row 2: PU/T/D/C, Authority, Quality Score -->
			<div class="kanban-row">
				<div class="kanban-cell ellipsis">
					PU: {{ projectCarrierMap.carrier.powerUnits || 'N/A' }} / T: {{ projectCarrierMap.carrier.trailers || 'N/A' }} / D: {{ projectCarrierMap.carrier.drivers || 'N/A' }}
				</div>
				<div class="kanban-cell ellipsis">
					Auth: {{ projectCarrierMap.carrier.authorityGrantDate ? DATE_MDY(projectCarrierMap.carrier.authorityGrantDate) : 'N/A' }}
				</div>
				<div class="kanban-cell" *ngIf="accountSettings.CARRIER_QUALITY">
					<span class="font-weight-bold {{ getCcScoreDisplay(projectCarrierMap.carrier.accountCarrierMaps, projectCarrierMap.carrier) || 'N/A' }}">
						{{ getCcScoreDisplay(projectCarrierMap.carrier.accountCarrierMaps, projectCarrierMap.carrier) || 'N/A' }}
					</span>
				</div>
			</div>

			<!-- Row 3: Lane, Last Load, Offered Rate -->
			<div class="kanban-row">
				<div class="kanban-cell ellipsis">
					{{ projectCarrierMap.lanePath || 'No Lane' }}
				</div>
				<div class="kanban-cell ellipsis">
					Last: {{ accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt ? (accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt | date: 'MM/dd/yy') : 'N/A' }}
				</div>
				<div class="kanban-cell ellipsis">
					Rate: {{ IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.desiredPrice) ? (projectCarrierMap.desiredPrice / 100 | currency: 'USD' : 'symbol' : '1.0-0') : 'N/A' }}
				</div>
			</div>
		</div>
	</cdk-virtual-scroll-viewport>
</div>

<!-- Standard View (V1/V2/V3 non-Kanban) -->
<div
	*ngIf="!isKanbanView && projectCarrierMapList?.length > 0"
	[ngClass]="{
		procured_carriers_container_for_project_group: showProcuredCarriersForGroup,
		procured_carriers_list_container: !showProcuredCarriersForGroup,
	}"
>
	<cdk-virtual-scroll-viewport
		itemSize="125"
		[minBufferPx]="20"
		[maxBufferPx]="40"
		style="flex: 1; overflow: auto"
	>
		<mat-accordion fxFlex="100">
			<div
				*cdkVirtualFor="
					let projectCarrierMap of projectCarrierMapList;
					let cIndex = index;
					trackBy: trackByFn
				"
				fxLayout="row"
				fxLayoutAlign="start stretch"
				[ngStyle]="{ 'margin-top': cIndex && cIndex > 0 ? (hideLastColumn ? '0.5rem' : '1rem') : 0 }"
				class="v2-card-row"
			>
				<!-- CN-8312 V2: leading bulk-select gutter (outside the card) -->
				<div *ngIf="showBulkSelectGutter" class="v2-bulk-select-gutter" (click)="$event.stopPropagation()">
					<mat-checkbox
						color="primary"
						[checked]="selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id) > -1"
						(change)="emitBulkSelectToggle(projectCarrierMap)"
						(click)="$event.stopPropagation()"
						aria-label="Select carrier"
					></mat-checkbox>
				</div>
				<mat-expansion-panel
					#panel
					fxFlex
					[expanded]="step == cIndex"
					[class.is-expanded]="step === cIndex"
					[hideToggle]="true"
					[ngClass]="{
						'mat-elevation-z4 primary-border': selectedMatch?.id == projectCarrierMap.id,
						'panel-selected mat-elevation-z4':
							selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id) > -1,
					}"
					class="custom-panel mat-elevation-z1"
					[attr.id]="'procuredCarriers-' + projectCarrierMap.id"
				>
					<!-- V1 only: legacy check-icon multi-select button (V2 uses leading gutter) -->
					<button
						*ngIf="!hideLastColumn"
						mat-icon-button
						(click)="emitPanelClickedEvent(projectCarrierMap, $event, cIndex, true)"
						class="project-details-selection"
						matTooltip
						aria-label="Select carrier"
					>
					<mat-icon>check_circle</mat-icon>
				</button>

				<mat-expansion-panel-header
					(mousedown)="$event.stopImmediatePropagation()"
					(click)="
						$event.stopImmediatePropagation();
						emitPanelClickedEvent(projectCarrierMap, $event, cIndex, false)
					"
					(keydown.arrowdown)="$event.stopImmediatePropagation()"
					(keydown.arrowup)="$event.stopImmediatePropagation()"
					(keydown.enter)="$event.stopImmediatePropagation()"
					[dragData]="projectCarrierMap"
					dragImage="assets/icons/drag_indicator.svg"
					(dragend)="dragend()"
					(dragstart)="drag($event, projectCarrierMap)"
					dragTransitClass="no-border"
					draggable
					id="{{ projectCarrierMap.carrier.id }}"
				>
					<table class="full-width" fxFlex="100">
						<tr fxLayout="row">
							<td #businessNameContainer [fxFlex]="hideLastColumn ? (isAssignRepColumnVisibleInV2 ? '25' : '28') : ''" fxLayout="row" fxLayoutAlign="start center">
								<div
									[ngStyle]="{
										'max-width':
											'calc(' +
											(businessNameContainer?.offsetWidth
												? businessNameContainer.offsetWidth -
													(20 +
														(projectCarrierMap.carrierLastOpenedEmailAt ? 100 : 8) +
														(IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrier.active) &&
														!projectCarrierMap.carrier.active
															? 160
															: 8))
												: 230) +
											'px)',
									}"
									class="ellipsis"
								>
									<b *ngIf="projectCarrierMap.carrier.customerCarrier" class="font-size-16">
										{{
											GET_CARRIER_BUSINESS_NAME(
												projectCarrierMap.carrier.businessName,
												projectCarrierMap.carrier.doingBusinessAs
											)
										}}
									</b>
									<span *ngIf="!projectCarrierMap.carrier.customerCarrier" class="font-size-16">
										{{
											GET_CARRIER_BUSINESS_NAME(
												projectCarrierMap.carrier.businessName,
												projectCarrierMap.carrier.doingBusinessAs
											)
										}}
									</span>
								</div>

								<div
									*ngIf="
										SHOW_IN_NETWORK_LOGO(
											CARRIER_QUALITY_ENABLED,
											projectCarrierMap.carrier.dot,
											isCarrierVettingIntegrationEnabled,
											getVettingSource(projectCarrierMap.carrier.accountCarrierMaps),
											getVettingSourceId(projectCarrierMap.carrier.accountCarrierMaps),
											carrierVettingService,
											projectCarrierMap.carrier.id,
											projectCarrierMap.carrier.customerCarrier
										)
									"
									fxLayoutAlign="start center"
								>
									<img
										[src]="
											carrierVettingService.logo(
												getVettingSource(projectCarrierMap.carrier.accountCarrierMaps)
											)
										"
										[matTooltip]="
											carrierVettingService.tooltip(
												getVettingSource(projectCarrierMap.carrier.accountCarrierMaps),
												getAccountCarrierMap(
													projectCarrierMap.carrier.accountCarrierMaps,
													projectCarrierMap.carrier
												)?.carrierOnboardedOn,
												getAccountCarrierMap(
													projectCarrierMap.carrier.accountCarrierMaps,
													projectCarrierMap.carrier
												)?.lastVettingTime
											)
										"
										class="h-18 in_network_logo"
									/>
								</div>

								<span
									*ngIf="showOnboardCarrier(projectCarrierMap.carrier)"
									class="link ml-6 font-size-12"
									fxLayoutAlign="start center"
									role="button"
									tabindex="0"
									(click)="$event.stopImmediatePropagation(); onboardCarrier(projectCarrierMap.carrier)"
									(keydown.enter)="$event.stopImmediatePropagation(); onboardCarrier(projectCarrierMap.carrier)"
									(keydown.space)="$event.preventDefault(); $event.stopImmediatePropagation(); onboardCarrier(projectCarrierMap.carrier)"
								>
									Onboard Carrier
								</span>

								<img
									*ngIf="projectCarrierMap.carrier?.haulPayApproved && environment.SHOW_QUALITY"
									class="h-18 in_network_logo"
									[src]="haulpayService.logo()"
									[matTooltip]="haulpayService.tooltip()"
								/>

								<span
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrierLastOpenedEmailAt)"
									class="font-size-16"
								>
									(RFP Viewed)
								</span>

								<!-- Allocation indicator -->
								<span
									*ngIf="isWorkflowProject && hasActiveAllocation(projectCarrierMap.carrier.id)"
									class="allocation-badge m-l-0-5"
									[matTooltip]="'Allocation: ' + getAllocationSummary(projectCarrierMap.carrier.id)"
								>
									<mat-icon class="font-size-14 allocation-icon">pie_chart</mat-icon>
									<span class="allocation-text">{{ getAllocationSummary(projectCarrierMap.carrier.id) }}</span>
								</span>
								<div
									*ngIf="
										IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrier.active) &&
										!projectCarrierMap.carrier.active
									"
									class="font-size-12"
								>
									Carrier not authorized.
								</div>
							</td>

							<!-- V1 Layout: Quality Score in column 2 -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start start">
								<div
									class="full-width p-r-1 p-l-1"
									(click)="$event.stopPropagation()"
									fxLayoutAlign="space-between center"
									*ngIf="accountSettings.CARRIER_QUALITY"
								>
									<span class="font-size-14 font-weight-bold">Quality Score: </span>
									<span
										class="font-size-14 font-weight-bold {{
											getCcScoreDisplay(
												projectCarrierMap.carrier.accountCarrierMaps,
												projectCarrierMap.carrier
											) || 'N/A'
										}}"
									>
										{{
											getCcScoreDisplay(
												projectCarrierMap.carrier.accountCarrierMaps,
												projectCarrierMap.carrier
											) || 'N/A'
										}}
									</span>
								</div>
							</td>

							<!-- V2/V3 Layout: Quality Score in column 2 -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '17' : '19'" fxLayoutAlign="start center">
								<div
									class="full-width p-r-1 ellipsis"
									(click)="$event.stopPropagation()"
									*ngIf="accountSettings.CARRIER_QUALITY"
								>
									<span class="font-size-14 font-weight-bold">Quality Score:&nbsp;</span>
									<span
										class="font-size-14 font-weight-bold {{
											getCcScoreDisplay(
												projectCarrierMap.carrier.accountCarrierMaps,
												projectCarrierMap.carrier
											) || 'N/A'
										}}"
									>
										{{
											getCcScoreDisplay(
												projectCarrierMap.carrier.accountCarrierMaps,
												projectCarrierMap.carrier
											) || 'N/A'
										}}
									</span>
								</div>
							</td>

							<!-- V1 Layout: Match Confidence in column 3 -->
							<td *ngIf="!hideLastColumn" fxFlex="21" fxLayoutAlign="start center">
								<div
									class="full-width"
									(click)="$event.stopPropagation()"
									fxLayoutAlign="space-between center"
									*ngIf="projectCarrierMap.matchScore; else na"
								>
									<span class="font-size-14"> Match Confidence </span>
									<span class="font-size-14 font-weight-bold success-text">
										<meter
											high="66"
											low="33"
											max="100"
											min="0"
											optimum="90"
											value="{{ projectCarrierMap.matchScore }}"
											[matTooltip]="projectCarrierMap.matchScore"
											matTooltipClass="custom-tooltip"
										></meter>
									</span>
								</div>
							</td>

							<!-- V2/V3 Layout: Match Score in column 3 -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '25'" fxLayoutAlign="start center">
								<div
									class="full-width p-r-1"
									(click)="$event.stopPropagation()"
									fxLayoutAlign="start center"
									*ngIf="projectCarrierMap.matchScore != null; else na"
								>
									<span class="font-size-14 font-weight-bold text-nowrap">Match Score:&nbsp;</span>
									<span class="font-size-14 font-weight-bold success-text">
										<meter
											high="66"
											low="33"
											max="100"
											min="0"
											optimum="90"
											value="{{ projectCarrierMap.matchScore }}"
											[matTooltip]="projectCarrierMap.matchScore"
											matTooltipClass="custom-tooltip"
										></meter>
									</span>
								</div>
							</td>

							<!-- V1 Layout: Empty spacer column 4 -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start center"></td>

							<!-- V2/V3 Layout: Last Contact in row 1 col 4 (moved up from row 2) -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '28'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Last Contact:&nbsp;</span>
									<span class="font-size-14">
										{{
											IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.recentFeedbackDate)
												? (projectCarrierMap.recentFeedbackDate | date: 'MM/dd/yyyy')
												: 'N/A'
										}}
									</span>
								</div>
							</td>

							<!-- CN-8312 V2: Only render this column when Assign Rep is populated.
							     In V1 always render to preserve original layout. Without this gate,
							     V2 row 1 sums to 119% (28+19+25+28+19) and the browser falls back to
							     equal distribution, breaking column widths and truncating text. -->
							<td
								*ngIf="
									!hideLastColumn ||
									(productsService.ASSIGN_CARRIERS &&
										IS_NOT_NULL_OR_UNDEFINED(usersList) &&
										usersList.length > 0 &&
										IS_NOT_NULL_OR_UNDEFINED(userCarrierMapList))
								"
								[fxFlex]="hideLastColumn ? '14' : '11'"
								fxLayout="row"
								fxLayoutAlign="start center"
								class="p-l-1"
							>
								<div
									fxFlex
									*ngIf="
										productsService.ASSIGN_CARRIERS &&
										IS_NOT_NULL_OR_UNDEFINED(usersList) &&
										usersList.length > 0 &&
										IS_NOT_NULL_OR_UNDEFINED(userCarrierMapList)
									"
								>
									<app-user-selector
										(userChanged)="setAssignee($event, projectCarrierMap.carrier.id)"
										[selectedUsers]="
											IS_NULL_OR_UNDEFINED(userCarrierMap[projectCarrierMap.carrier.id])
												? []
												: [getUserIdAssigned(projectCarrierMap.carrier.id)]
										"
										[showAssignMe]="false"
										[singleselect]="true"
										[usersList]="usersList"
										[allUsersList]="allUsersList"
										customCssClass="custom-form-field assignn_rep_max_width"
										floatLabel="never"
										placeholder="Assign Rep"
									></app-user-selector>
								</div>
							</td>
						</tr>

						<tr class="font-size-14 mt-3" fxLayout="row">
							<td [fxFlex]="hideLastColumn ? (isAssignRepColumnVisibleInV2 ? '25' : '28') : ''">
								<!-- V1 Layout: MC/DOT in row 2 col 1 -->
								<div *ngIf="!hideLastColumn" (click)="$event.stopPropagation()" fxLayoutAlign="start center">
									<span
										#mcDotContainer
										*ngIf="
											IS_NOT_EMPTY(projectCarrierMap.carrier.dot) ||
											IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
										"
										class="font-size-14"
									>
										<span
											(click)="
												utilService.copyToClipboard(
													projectCarrierMap.carrier.mc,
													COPY_TO_CLIPBOARD_MSGS.MC
												)
											"
											*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.mc)"
										>
											MC: {{ projectCarrierMap.carrier.mc }}
										</span>
										{{
											IS_NOT_EMPTY(projectCarrierMap.carrier.dot) &&
											IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
												? ' / '
												: ''
										}}
										<span
											(click)="
												utilService.copyToClipboard(
													projectCarrierMap.carrier.dot,
													COPY_TO_CLIPBOARD_MSGS.DOT
												)
											"
											*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.dot)"
										>
											DOT: {{ projectCarrierMap.carrier.dot }}
										</span>
									</span>
								</div>
								<!-- V2/V3 Layout: MC/DOT in row 2 col 1 (under carrier name, above PU/T/D/C) -->
								<div *ngIf="hideLastColumn" (click)="$event.stopPropagation()" class="full-width" fxLayoutAlign="start center">
									<span
										*ngIf="
											IS_NOT_EMPTY(projectCarrierMap.carrier.dot) ||
											IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
										"
										class="font-size-14"
									>
										<span
											(click)="
												utilService.copyToClipboard(
													projectCarrierMap.carrier.mc,
													COPY_TO_CLIPBOARD_MSGS.MC
												)
											"
											*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.mc)"
										>
											<span class="font-weight-bold">MC:</span> {{ projectCarrierMap.carrier.mc }}
										</span>
										{{
											IS_NOT_EMPTY(projectCarrierMap.carrier.dot) &&
											IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
												? ' / '
												: ''
										}}
										<span
											(click)="
												utilService.copyToClipboard(
													projectCarrierMap.carrier.dot,
													COPY_TO_CLIPBOARD_MSGS.DOT
												)
											"
											*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.dot)"
										>
											<span class="font-weight-bold">DOT:</span> {{ projectCarrierMap.carrier.dot }}
										</span>
									</span>
								</div>
							</td>
							<!-- V1 Layout: Column widths -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Authority:</span>
									<span>
										{{
											projectCarrierMap.carrier.authorityGrantDate
												? DATE_MDY(projectCarrierMap.carrier.authorityGrantDate)
												: 'N/A'
										}}
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Authority in column 2 -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '17' : '19'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Authority:&nbsp;</span>
									<span class="font-size-14">
										{{
											projectCarrierMap.carrier.authorityGrantDate
												? DATE_MDY(projectCarrierMap.carrier.authorityGrantDate)
												: 'N/A'
										}}
									</span>
								</div>
							</td>
							<!-- V1 Layout: Lane in column 3 -->
							<td *ngIf="!hideLastColumn" fxFlex="21" fxLayoutAlign="start center">
								<div class="full-width" fxLayoutAlign="space-between center">
									<span>Lane:&nbsp;</span>
									<span
										*ngIf="projectCarrierMap.lanePath; else na"
										[appTruncateTooltip]="projectCarrierMap.lanePath || ''"
										class="font-size-12 truncate_text"
									>
										{{ projectCarrierMap.lanePath }}
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Lane in column 3 -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '25'" fxLayoutAlign="start center">
								<div
									class="full-width p-r-1 ellipsis"
									[matTooltip]="projectCarrierMap.lanePath || ''"
									[matTooltipDisabled]="!projectCarrierMap.lanePath"
									matTooltipClass="custom-tooltip"
								>
									<span class="font-size-14 font-weight-bold">Lane:&nbsp;</span>
									<span class="font-size-14" *ngIf="projectCarrierMap.lanePath">
										{{ projectCarrierMap.lanePath }}
									</span>
									<span class="font-size-14" *ngIf="!projectCarrierMap.lanePath">N/A</span>
								</div>
							</td>
							<!-- V1 Layout: Last Contact in row 2 col 4 -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Last Contact:</span>
									<span>
										{{
											IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.recentFeedbackDate)
												? (projectCarrierMap.recentFeedbackDate | date: 'MM/dd/yyyy')
												: 'N/A'
										}}
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Contact name in row 2 col 4 -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '28'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Contact:&nbsp;</span>
									<span class="font-size-14">
										{{ projectCarrierMap.carrier.representative1 || 'N/A' }}
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Spacer column 5 -->
							
							<td fxFlex="11" fxLayoutAlign="end end" *ngIf="!hideLastColumn">
								<div
									class="full-width"
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.laneCount)"
									(click)="
										$event.stopPropagation();
										emitOpenFullProfileEventEvent(projectCarrierMap, $event)
									"
									fxLayoutAlign="space-between center"
								>
									<span>
										{{
											projectCarrierMap.laneCount +
												' Lane' +
												(projectCarrierMap.laneCount > 1 ? 's' : '')
										}}
									</span>
									<span>
										<img class="ml-4" height="18px" src="./assets/icons/road.svg" />
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: trailing placeholder reserved for the missing Assign Rep
							     slot in this row, so col widths align with row 1 across all rows. -->
							<td *ngIf="isAssignRepColumnVisibleInV2" fxFlex="14"></td>
						</tr>

						<tr class="font-size-14 mt-3" fxLayout="row">
							<td [fxFlex]="hideLastColumn ? (isAssignRepColumnVisibleInV2 ? '25' : '28') : ''">
								<!-- V1 Layout: PU/T/D/C in row 3 col 1 -->
								<div *ngIf="!hideLastColumn" class="full-width" fxLayoutAlign="start center">
									<span>PU: {{ projectCarrierMap.carrier.powerUnits }}</span>
									<span>&nbsp; / &nbsp;</span>
									<span>T: {{ projectCarrierMap.carrier.trailers }}</span>
									<span>&nbsp; / &nbsp;</span>
									<span>D: {{ projectCarrierMap.carrier.drivers }}</span>
									<span>&nbsp;/ C: {{ projectCarrierMap.carrier.contacts.length || 'N/A' }} </span>
								</div>
								<!-- V2/V3 Layout: PU/T/D/C in row 3 col 1 (after MC/DOT row) -->
								<div *ngIf="hideLastColumn" class="full-width" fxLayoutAlign="start center">
									<span><span class="font-weight-bold">PU:</span> {{ projectCarrierMap.carrier.powerUnits || 'N/A' }}</span>
									<span>&nbsp; / &nbsp;</span>
									<span><span class="font-weight-bold">T:</span> {{ projectCarrierMap.carrier.trailers || 'N/A' }}</span>
									<span>&nbsp; / &nbsp;</span>
									<span><span class="font-weight-bold">D:</span> {{ projectCarrierMap.carrier.drivers || 'N/A' }}</span>
									<span>&nbsp;/ <span class="font-weight-bold">C:</span> {{ projectCarrierMap.carrier.contacts?.length ?? 'N/A' }} </span>
								</div>
							</td>
							<!-- V1 Layout: Column widths -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Insurance: </span>
									<span *ngIf="projectCarrierMap.carrier.cargoInsuranceAmount">
										{{
											projectCarrierMap.carrier.cargoInsuranceAmount
												| currency: 'USD' : 'symbol' : '1.0-0'
										}}
									</span>
									<span *ngIf="!projectCarrierMap.carrier.cargoInsuranceAmount">N/A</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Insurance in column 2 -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '17' : '19'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Insurance:&nbsp;</span>
									<span class="font-size-14" *ngIf="projectCarrierMap.carrier.cargoInsuranceAmount">
										{{
											projectCarrierMap.carrier.cargoInsuranceAmount
												| currency: 'USD' : 'symbol' : '1.0-0'
										}}
									</span>
									<span class="font-size-14" *ngIf="!projectCarrierMap.carrier.cargoInsuranceAmount">N/A</span>
								</div>
							</td>
							<!-- V1 Layout: Frequency -->
							<td *ngIf="!hideLastColumn" fxFlex="21" fxLayoutAlign="start center">
								<div class="full-width" fxLayoutAlign="space-between center">
									<span> Frequency: </span>
									<span
										*ngIf="projectCarrierMap.frequency; else na"
										[appTruncateTooltip]="projectCarrierMap.lanePath || ''"
										class="font-size-12 truncate_text"
									>
										{{ projectCarrierMap.frequency }}
										{{
											!utilService.isNullOrUndefined(projectCarrierMap.frequency) &&
											isFrequencyValidNumber(projectCarrierMap.frequency)
												? '/ weekly'
												: ''
										}}
									</span>
								</div>
							</td>
							<!-- V1 Layout: Last Load in row 3 col 4 -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Last Load:</span>
									<span *ngIf="accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt">
										{{
											accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt
												| date: 'MM/dd/yyyy'
										}}
									</span>
									<span *ngIf="!accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt">
										N/A
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Last Load in row 3 col 3 -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '25'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Last Load:&nbsp;</span>
									<span class="font-size-14">
										{{
											accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt
												? (accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt | date: 'MM/dd/yyyy')
												: 'N/A'
										}}
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Email in row 3 col 4 (below Contact) -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '28'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Email:&nbsp;</span>
									<span class="font-size-14" *ngIf="projectCarrierMap.carrier.businessEmailAddress">
										<a
											href="mailto:{{ projectCarrierMap.carrier.businessEmailAddress }}"
											(click)="$event.stopPropagation()"
										>{{ projectCarrierMap.carrier.businessEmailAddress?.toLowerCase() }}</a>
									</span>
									<span class="font-size-14" *ngIf="!projectCarrierMap.carrier.businessEmailAddress">N/A</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Spacer column 5 -->
														<td fxFlex="11" fxLayoutAlign="end center" *ngIf="!hideLastColumn">
								<div
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.notesCount)"
									class="full-width"
									(click)="$event.stopPropagation()"
								>
									<div
										*ngIf="projectCarrierMap.notesCount > 0"
										fxLayoutAlign="space-between center"
										class="full-width"
									>
										<span>
											{{
												projectCarrierMap.notesCount +
													' Note' +
													(projectCarrierMap.notesCount > 1 ? 's' : '')
											}}
										</span>
										<span fxLayoutAlign="start center">
											<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
										</span>
									</div>
									<div
										*ngIf="projectCarrierMap.notesCount == 0"
										fxLayoutAlign="space-between center"
										class="full-width"
									>
										<span class="primary-text">No Notes</span>
										<span fxLayoutAlign="start center">
											<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
										</span>
									</div>
								</div>
							</td>
							<!-- V2/V3 Layout: trailing placeholder reserved for the missing Assign Rep
							     slot in this row, so col widths align with row 1 across all rows. -->
							<td *ngIf="isAssignRepColumnVisibleInV2" fxFlex="14"></td>
						</tr>

						<tr class="font-size-14 mt-3" fxLayout="row">
							<td [fxFlex]="hideLastColumn ? (isAssignRepColumnVisibleInV2 ? '25' : '28') : ''">
								<!-- V1 Layout: HQ in row 4 col 1 -->
								<div
									*ngIf="!hideLastColumn"
									class="full-width"
									fxLayoutAlign="start center"
								>
									<ng-container
										*ngIf="
											IS_NOT_EMPTY(projectCarrierMap.carrier.city) ||
											IS_NOT_EMPTY(projectCarrierMap.carrier.state)
										"
									>
										HQ:&nbsp;
										<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.city)">
											{{ projectCarrierMap.carrier.city
											}}{{ IS_NOT_EMPTY(projectCarrierMap.carrier.state) ? ',' : '' }}
										</span>
										<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.state)">
											{{ projectCarrierMap.carrier.state }}
										</span>
									</ng-container>
								</div>
								<!-- V2/V3 Layout: HQ in row 4 col 1 (was empty; pushed down by MC/DOT row) -->
								<div
									*ngIf="hideLastColumn"
									class="full-width"
									fxLayoutAlign="start center"
								>
									<ng-container
										*ngIf="
											IS_NOT_EMPTY(projectCarrierMap.carrier.city) ||
											IS_NOT_EMPTY(projectCarrierMap.carrier.state)
										"
									>
										<span class="font-weight-bold">HQ:</span>&nbsp;
										<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.city)">
											{{ projectCarrierMap.carrier.city
											}}{{ IS_NOT_EMPTY(projectCarrierMap.carrier.state) ? ',' : '' }}
										</span>
										<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.state)">
											{{ projectCarrierMap.carrier.state }}
										</span>
									</ng-container>
								</div>
							</td>
							<!-- V2/V3 Layout: empty Col 2 placeholder so Last Rate / Phone align with Col 3 / Col 4 above -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '17' : '19'"></td>
							<!-- V1 Layout: Column widths -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Violations: </span>
									<span>N/A</span>
								</div>
							</td>
							<!-- V1 Layout: DH-O/DH-D in row 4 col 3 -->
							<td *ngIf="!hideLastColumn" fxFlex="21" fxLayoutAlign="start center">
								<div class="full-width" fxLayoutAlign="space-between center">
									<span>
										<span>DH-O:</span>
										<span
											*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.originDeadhead); else na"
										>
											{{ projectCarrierMap.originDeadhead | number: '1.0-0' }}
										</span>
									</span>
									<span>
										<span class="m-l-1">DH-D:</span>
										<span
											*ngIf="
												IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.destinationDeadhead);
												else na
											"
										>
											{{ projectCarrierMap.destinationDeadhead | number: '1.0-0' }}
										</span>
									</span>
								</div>
							</td>
							<!-- V1 Layout: Offered Rate in row 4 col 4 -->
							<td *ngIf="!hideLastColumn" fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Offered Rate:</span>
									<span
										*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.desiredPrice)"
										class="font-size-14"
									>
										{{
											projectCarrierMap.desiredPrice / 100 | currency: 'USD' : 'symbol' : '1.0-2'
										}}
									</span>
									<span
										*ngIf="IS_NULL_OR_UNDEFINED(projectCarrierMap.desiredPrice)"
										class="font-size-14"
									>
										N/A
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Offered Rate in row 4 col 3 (below Last Load) -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '25'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Offered Rate:&nbsp;</span>
									<span
										*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.desiredPrice)"
										class="font-size-14"
									>
										{{
											projectCarrierMap.desiredPrice / 100 | currency: 'USD' : 'symbol' : '1.0-2'
										}}
									</span>
									<span
										*ngIf="IS_NULL_OR_UNDEFINED(projectCarrierMap.desiredPrice)"
										class="font-size-14"
									>
										N/A
									</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Phone in row 4 col 4 (below Email) -->
							<td *ngIf="hideLastColumn" [fxFlex]="isAssignRepColumnVisibleInV2 ? '22' : '28'" fxLayoutAlign="start center">
								<div class="full-width p-r-1 ellipsis">
									<span class="font-size-14 font-weight-bold">Phone:&nbsp;</span>
									<span class="font-size-14" *ngIf="projectCarrierMap.carrier.phone">
										<a
											href="tel:{{ projectCarrierMap.carrier.phone }}"
											(click)="$event.stopPropagation()"
										>{{ projectCarrierMap.carrier.phone }}</a>
									</span>
									<span class="font-size-14" *ngIf="!projectCarrierMap.carrier.phone">N/A</span>
								</div>
							</td>
							<!-- V2/V3 Layout: Empty spacer column 5 -->
														<td fxFlex="11" fxLayoutAlign="start center" *ngIf="!hideLastColumn">
								<div class="full-width" *ngIf="projectCarrierMap.projectsList">
									<div
										fxLayoutAlign="space-between center"
										class="full-width dropdown"
										*ngIf="projectCarrierMap.projectsList?.length > 0"
									>
										<span>
											{{ projectCarrierMap.projectsList.length }}
											{{ projectCarrierMap.projectsList.length > 1 ? 'Projects' : 'Project' }}
										</span>
										<span fxLayoutAlign="start center">
											<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
										</span>
									</div>

									<div
										fxLayoutAlign="space-between center"
										class="full-width"
										*ngIf="projectCarrierMap.projectsList.length == 0"
									>
										<span class="primary-text">No Projects</span>
										<span fxLayoutAlign="start center">
											<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
										</span>
									</div>
								</div>
							</td>
							<!-- V2/V3 Layout: trailing placeholder reserved for the missing Assign Rep
							     slot in this row, so col widths align with row 1 across all rows. -->
							<td *ngIf="isAssignRepColumnVisibleInV2" fxFlex="14"></td>
						</tr>
						<tr class="font-size-14 mt-3" fxLayout="row" *ngIf="step === cIndex && !hideLastColumn">
							<td [fxFlex]="hideLastColumn ? (isAssignRepColumnVisibleInV2 ? '25' : '28') : ''" fxLayoutAlign="start center">
								<div
									fxLayoutAlign="end center"
									(click)="
										utilService.copyToClipboard(
											projectCarrierMap.carrier.businessEmailAddress,
											COPY_TO_CLIPBOARD_MSGS.EMAIL
										)
									"
									*ngIf="projectCarrierMap.carrier.businessEmailAddress"
								>
									<span class="text-nowrap">Main Email:</span>
									<span class="font-size-14 truncate_text">
										<a href="mailto:{{ projectCarrierMap.carrier.businessEmailAddress }}">{{
											projectCarrierMap.carrier.businessEmailAddress?.toLowerCase()
										}}</a>
									</span>
								</div>
							</td>
							<td [fxFlex]="hideLastColumn ? '19' : '20'" fxLayoutAlign="start center">
								<div
									fxLayoutAlign="space-between center"
									class="full-width p-r-1 p-l-1"
									*ngIf="projectCarrierMap.carrier.representative1"
								>
									<span class="text-nowrap">Contact:</span>
									<span class="font-size-12 truncate_text capitalize">{{
										projectCarrierMap.carrier.representative1?.toLowerCase()
									}}</span>
								</div>
							</td>
							<td [fxFlex]="hideLastColumn ? '19' : '21'">
								<div
									fxLayoutAlign="space-between center"
									class="full-width"
									*ngIf="projectCarrierMap.carrier.phone"
								>
									<span>Phone:</span>
									<span
										><a href="tel:{{ projectCarrierMap.carrier.phone }}">{{
											projectCarrierMap.carrier.phone
										}}</a></span
									>
								</div>
							</td>
							<td [fxFlex]="hideLastColumn ? '19' : '20'">
								<div
									fxLayoutAlign="space-between center"
									class="full-width p-r-1 p-l-1"
									*ngIf="projectCarrierMap.carrier.cellPhone"
								>
									<span>Cell:</span>
									<span
										><a href="tel:{{ projectCarrierMap.carrier.cellPhone }}">{{
											projectCarrierMap.carrier.cellPhone
										}}</a></span
									>
								</div>
							</td>
							<!-- CN-8312 V2: empty trailing spacer is a V1-only Assign Rep slot.
							     Drop in V2 so the row sums to 100% and column widths apply. -->
							<td *ngIf="!hideLastColumn" [fxFlex]="hideLastColumn ? '19' : '11'"></td>
						</tr>
					</table>
				</mat-expansion-panel-header>

				<ng-template [ngIf]="step == cIndex">
					<div fxLayout="row">
						<div fxFlex fxLayoutAlign="end end" fxLayoutGap="16px">
							<a
								(click)="emitOpenFullProfileEventEvent(projectCarrierMap, $event)"
								class="cursor-pointer"
							>
								<span class="primary-text m-r-1 p-r-0-5"><u>Full Profile</u></span>
							</a>
						</div>
					</div>
					<div
						*ngIf="
							accountSettings.IS_FEEDBACK_ENABLED &&
							USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN &&
							accountId &&
							step == cIndex
						"
						class="p-l-1 p-r-1"
					>
						<app-carrier-feedbacks
							[accountId]="accountId"
							[carrierId]="projectCarrierMap.carrier.id"
						>
						</app-carrier-feedbacks>
					</div>
					<div class="p-l-1 p-r-1" fxLayout="row">
						<h3 class="primary-text" fxFlex>Representatives</h3>
					</div>
					<div class="p-l-1 p-r-1 p-b-1" *ngIf="isContactsListInitialised">
						<app-carrier-contacts
							(updateContactsList)="updateContactsList($event)"
							(onProjectCarrierMapContact)="onProjectCarrierMapContact($event)"
							[carrierId]="projectCarrierMap.carrier.id"
							[carrier]="projectCarrierMap?.carrier"
							[contactList]="contactList"
							[editPrimaryContact]="false"
							[isCarrierProfile]="true"
							[isEditContact]="true"
							[oldCarrierId]="null"
							[showContactSearchIcon]="true"
							[mapContactToProjectColumnEnabled]="true"
							[projectCarrierMap]="selectedProjectCarrierMap | async"
							[rowSelectionEnabled]="true"
							[showAddContactIcon]="false"
						>
						</app-carrier-contacts>
					</div>
				</ng-template>
			</mat-expansion-panel>
		</div>
		</mat-accordion>
	</cdk-virtual-scroll-viewport>
</div>

<ng-template #na>
	<span> N/A </span>
</ng-template>
